let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dVY78")).then(() => parcelRequire('3L8eJ'));